const initialState = {
  fetching: false,
  fetched: false,
  updating: false,
  updated: false,
  items: [],
  error: null,
  team: [],
  nbResult: 0
};
export const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case "RESET_TEAM": {
      return { ...initialState };
    }
    case "FETCH_TEAM_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }

    case "FETCH_TEAM_FULFILLED": {
      const { data, nbResult } = action.payload.data;

      // Ovoid duplicates
      const newItems = (data || []).filter(newItem => {
        return !state.items.find(item => item.id === newItem.id);
      });

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: state.items.concat(newItems),
        nbResult: nbResult
      };
    }
    case "FETCH_TEAM_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case "ADD_USER_TO_TEAM": {
      const { id, order } = action;
      const help = [...state.team];
      help.push({ id, order });

      return {
        ...state,
        team: [...help]
      };
    }
    case "SET_USER_ORDER": {
      const { id, order } = action;
      const help = [...state.team];
      help.push({ id, order });

      return {
        ...state,
        team: state.team.map(user => {
          return user.id === id
            ? { ...user, order: parseInt(order, 10) }
            : { ...user };
        })
      };
    }
    case "REMOVE_USER_FROM_TEAM": {
      return {
        ...state,
        team: state.team.filter(user => user.id !== action.id)
      };
    }
    case "SET_TEAM": {
      return {
        ...state,
        team: [...action.users]
      };
    }
    case "SAVE_TEAM_SETTINGS_PENDING": {
      return { ...state, updated: false, updating: true };
    }
    case "SAVE_TEAM_SETTINGS_FULFILLED": {
      return {
        ...state,
        updating: false,
        updated: true
      };
    }
    case "SAVE_TEAM_SETTINGS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        updating: false,
        updated: false,
        error
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/user.js